import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import useUserAction from "../../../hooks/user/useUserAction";
import {useTranslation} from "react-i18next";
import {PAGE_APPLICATIONS} from "../../../locales/pages/namespaces";

const ModalTimeout = ({ open, reset }) => {
    const { userLogout } = useUserAction();
    const {t} = useTranslation(PAGE_APPLICATIONS)
    return (
        <Dialog open={open}>
            <DialogTitle>{t("Session Timeout")}</DialogTitle>
            <DialogContent>{t("Your time has expired. What would you like to do?")}</DialogContent>
            <DialogActions>
                <Button onClick={reset}>{t("Reset timer")}</Button>
                <Button onClick={userLogout} color="error"> {t("Exit")}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalTimeout;
